import { render, staticRenderFns } from "./clone.vue?vue&type=template&id=2b2c4ee2&"
import script from "./clone.vue?vue&type=script&lang=js&"
export * from "./clone.vue?vue&type=script&lang=js&"
import style0 from "./clone.vue?vue&type=style&index=0&socped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports